<template>
  <v-app
    v-if="$auth.user"
    id="washwerk"
  >
    <app-messages />
    <app-layout-drawer v-if="$vuetify.display.mdAndUp" />
    <app-layout-bottom-drawer v-else />
    <app-layout-toolbar />
    <div id="outside-main" />
    <v-main>
      <slot />
    </v-main>

    <active-maintenance />
  </v-app>
</template>

<script lang="ts">
import AppLayoutToolbar from '@/components/AppLayoutToolbar.vue'
import AppLayoutDrawer from '@/components/AppLayoutDrawer.vue'
import ActiveMaintenance from '@/components/ActiveMaintenance.vue'
import AppLayoutBottomDrawer from '@/components/AppLayoutBottomDrawer.vue'
import { defineComponent } from 'vue'
import AppMessages from '@/components/AppMessages.vue'

export default defineComponent({
  components: {
    AppLayoutBottomDrawer,
    ActiveMaintenance,
    AppLayoutDrawer,
    AppLayoutToolbar,
    AppMessages,
  },
  middleware: ['stores', 'preventCorporateForSingleStoreCompanies'],
  mounted() {
    this.$push.requestPermissions()
  },
})
</script>

<style scoped>
.v-main {
  padding-top: calc(var(--v-layout-top) + var(--v-safe-area-top));
  padding-bottom: calc(var(--v-layout-bottom) + var(--v-safe-area-bottom));
}
</style>
